export type RestaurantHighlightLegendTone = 'new' | 'updated'

export const restaurantHighlightTokens = {
  row: {
    background: '#FFFEE8',
    legendSwatchBorderColor: '#EADCA6',
  },
  updated: {
    color: '#E25A2C',
  },
} as const

export const restaurantHighlightLegendItems: ReadonlyArray<{
  tone: RestaurantHighlightLegendTone
  labelKey: 'RestaurantManager.HighlightLegendNew' | 'RestaurantManager.HighlightLegendUpdated'
}> = [
  {
    tone: 'new',
    labelKey: 'RestaurantManager.HighlightLegendNew',
  },
  {
    tone: 'updated',
    labelKey: 'RestaurantManager.HighlightLegendUpdated',
  },
]
